import React from "react";

import {
    Button,
    Card,  CardHeader,  CardBody,  CardTitle,
    Row,  Col,
    FormGroup,
    Modal, ModalBody,ModalFooter
  } from "reactstrap";

import ReactTable from "react-table-legacy";
import { Link } from 'react-router-dom';

import Request from '../../common/Request';

import InputText from '../FormParts/InputText';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip'
import Definition from '../../common/Definition';
import WithRole from '../FormParts/ButtonWithRole';

export default class CustomerSelectPopupWithOrder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            data: [],
            column: this.default_column,
            selectionChanged:"",
            selectionBranchChanged:"",
            customer_id: "",
            customer_branch_id: "",
            customer_name: "",
            customer_branch_name:"",
            customer_branch_tel: "",
            customer_user_name: "",
            customer_user_tel: "",
            customer_data: [],
            customer_branch_data: [],
            customer_user_data: [],
            customer_table:"off",
            branchBox: "off",
            userBox: "off",
            selected: null,
            tmp_cnt: "5",
            column:[{ Header: '会社名', accessor: 'customer_name', headerClassName: "text-left", className: "text-left text-top",minWidth:100 },
                    { Header: '会社ID', accessor: 'customer_id', show:false },
                    { Header: '', accessor: 'action', headerClassName: "text-center", className: "text-center" ,width:60, minWidth:60, sortable : false},
                    { Header: '', accessor: 'symbol', headerClassName:'text-center', className:'text-center',width:30, minWidth:30, sortable : false}],
            column_branch:[
                    { Header: '会社ID', accessor: 'customer_id', show:false },
                    { Header: '支店ID', accessor: 'customer_branch_id',show:false},
                    { Header: '支店名', accessor: 'customer_branch_name', headerClassName: "text-left ", className: "text-left text-top",minWidth:50  },
                    { Header: 'TEL', accessor: 'customer_branch_tel', headerClassName: "text-left ", className: "text-left text-top ",minWidth:80  },
                    //{ Header: 'FAX', accessor: 'customer_branch_fax', headerClassName: "text-left ", className: "text-left ",minWidth:80  },
                    { Header: '', accessor: 'action', headerClassName: "text-center", className: "text-center" ,width:60, minWidth:60, sortable : false},
                    { Header: '', accessor: 'symbol', headerClassName:'text-center', className:'text-center',width:30, minWidth:30, sortable : false}
                ],
            column_user:[
                    { Header: '担当者名', accessor: 'customer_user_name', headerClassName: "text-left ", className: "text-left text-top",width:100,minWidth:50  },
//                { Header: 'TEL', accessor: 'customer_user_tel', headerClassName: "text-left ", className: "text-left ",minWidth:50  },
//                { Header: 'アドレス', accessor: 'customer_user_email', headerClassName: "text-left ", className: "text-left ",minWidth:50  },
                    { Header: '連絡先', accessor: '__JOIN_customer_user_contact_information', headerClassName: "text-left ", className: "text-left text-top",width:100,minWidth:50  },
                    { Header: '', accessor: 'action_link', headerClassName: "text-center", className: "text-center",width:60, minWidth:60 , sortable : false},
                    { Header: 'アクション', accessor: 'action', headerClassName: "text-center", className: "text-center",width:70, minWidth:70 , sortable : false},
                    ],
            defaultPageSize: 300
        };
        this.setTmp = this.setTmp.bind(this);
        
        this.handle_customer_branch_name = this.handle_customer_branch_name.bind(this)
        this.handle_customer_branch_tel = this.handle_customer_branch_tel.bind(this)
        this.handle_customer_user_name = this.handle_customer_user_name.bind(this)
        this.handle_customer_user_tel = this.handle_customer_user_tel.bind(this)
        this.toggleModal = this.toggleModal.bind(this);
        this.search = this.search.bind(this);
        this.validate_customer_customer_name = this.validate_customer_customer_name.bind(this);
        this.clickSelectButton = this.clickSelectButton.bind(this);
        this.linkButton = this.linkButton.bind(this)
        this.setSelectedDataWithId = this.setSelectedDataWithId.bind(this)
        this.requestData = this.requestData.bind(this)
        this.validateCallback = this.validateCallback.bind(this)
    }

    symbol(value){
      return <span style={{color:"#344675", fontSize:"30px", weight:"500", marginLeft:"-10px", display: "block", height: "30px", marginTop: "-28px"}} dangerouslySetInnerHTML={{__html:value}}></span>
    }

    // 初期ロード用
    UNSAFE_componentWillMount() {
        /*　ここは開発者が記述　*/

        // TODO 本番では有効にする
        // this.search("");
    }

    validate_customer_customer_name(valid, text) {
        this.setState({ customer_customer_name_valid: valid, customer_customer_name: text }, () => { valid && this.search(); });
    }
    linkButton(label, toUrl, button_id, prop){
      const LinkWithRole = WithRole(Link, this.props.buttons, prop)
      return <LinkWithRole button_id={button_id} className="btn btn-secondary small-btn" target="_blank" to={toUrl}>
        <span style={{color:"white", textDecoration:"none"}}>{label}</span>
      </LinkWithRole>
    }

    dataMap(data) {
        return data.map((prop, key) => {
          
          return {
//            customer_name: (<Link to={"/customer/detail/"+prop.ulid}>{prop.customer_name}</Link>),
            customer_name: prop.customer_name,
            customer_name_view: prop.customer_name,
            customer_id:prop.ulid,
            action: this.linkButton('詳細', "/customer/detail/"+prop.ulid, (this.props.view?"BTN_A2_03_06005":""),prop),
            symbol: this.symbol("&#x27AD;")
          }
        });
      }
      dataBranchMap(data){
        return data.map((prop, key) => {
          return {
//            customer_branch_name: (<Link to={"detail/branch/"+prop.ulid}>{prop.customer_branch_name}</Link>),
            customer_branch_name: prop.customer_branch_name,
            customer_branch_name_view: prop.customer_branch_name,
//            customer_id:prop.customer_id,
            customer_branch_id:prop.ulid,
            customer_branch_tel:prop.customer_branch_tel,
            action: this.linkButton('詳細', "/customer/detail/branch/"+prop.ulid, undefined, prop),
            //customer_branch_fax:prop.customer_branch_fax,
            symbol: this.symbol("&#x27AD;")
          }
        });
      }
      dataUserMap(data){
        return data.map((prop, key) => {
          return {
            customer_user_name: prop.customer_user_name,
//            customer_user_name: (<Link to={"/customer/detail/user/"+prop.ulid}>{prop.customer_user_name}</Link>),
            __JOIN_customer_user_contact_information: <div dangerouslySetInnerHTML={{__html:Definition.item('__JOIN_customer_user_contact_information_with_tel2', prop)}} />,
            // customer_user_tel:prop.customer_user_tel,
            // customer_user_email:prop.customer_user_email,
            action_link: this.linkButton('詳細', "/customer/detail/user/"+prop.ulid, (this.props.view?"BTN_A2_03_06017":""), prop),
            action: (<Button type="button" color="default" className="btn-sm" onDoubleClick={()=>{return false;}} onClick={() => {this.clickSelectButton(prop); }}>選択</Button>)
          }
        });
      }
      setTmp(){
        if (this.state.tmp_set === "off") {
            this.setState({tmp_set:'on'});
        } else{
            this.setState({tmp_set:'off'});
        }
      }  
  // 検索
  search(name,customer_id,customer_branch_id) {
    /* ここは開発者が記述 */
    var domain = "";
    var url = domain + '/api/'+name;
    let params = {};

    switch(name){
      case "customer":
        
        this.setState({
        customer_table: 'on',
        branchBox:'off',
        userBox:'off'
        });
        if(this.state.customer_name != ""){
          params.customer_name = this.state.customer_name;
        }
        params.show_delete_data = 0
      break;
      case "customer/branch":
          if(customer_id == ""){
            return false;
          }
          this.setState({
            branchBox:'on',
            userBox:'off',
            customer_id:customer_id
          });
          params.customer_ulid = customer_id;
                 
          if(this.state.customer_branch_name != ""){
            params.customer_branch_name = this.state.customer_branch_name;
          }
          if(this.state.customer_branch_tel != ""){
            params.customer_branch_tel = this.state.customer_branch_tel;
          }
          params.show_delete_data = 0
          break;
      case "customer/user":
          if(customer_branch_id == ""){
            return false;
          }
          this.setState({branchBox:'on',
                         userBox:'on',
                         customer_branch_id:customer_branch_id,
                         customer_id,customer_id});
          params = {
            customer_branch_ulid: customer_branch_id,
            customer_user_name: this.state.customer_user_name?this.state.customer_user_name:undefined,
            customer_user_tel: this.state.customer_user_tel?this.state.customer_user_tel:undefined
          }
          params.show_delete_data = 0
        break;

    }
    // console.log(params);
    this.requestData(url, params, name)
  }

  requestData(url, params, name, callback=()=>{}){
    Request.get(url, params, res => {
      switch(name){
        case "customer":
            this.setState({
              customer_data: this.dataMap(res.data)
            }, ()=>callback());
        break;
        case "customer/branch":
            this.setState({
              customer_branch_data: this.dataBranchMap(res.data)
            }, ()=>callback());
        break;
        case "customer/user":
            this.setState({
              customer_user_data:this.dataUserMap( res.data)
            }, ()=>callback());
        break;
      }
    })
  }

    clickSelectButton(prop) {
        if (this.props.customerSelectedCallback) {
//            console.log(prop);
            this.props.customerSelectedCallback(prop);
        }
        if(document.body.style.overflow == "hidden"){
          document.body.style.overflow = "auto";
        }
        this.toggleModal();
    }

    show() {
        this.setState({ modal: true });
    }

    setSelectedDataWithId({customer_natural_id, customer_branch_natural_id, customer_user_natural_id}){
      const baseUrl = '/api/';
      this.requestData(baseUrl + "customer", {customer_natural_id}, "customer", ()=>{
        this.requestData(baseUrl + "customer/branch", {customer_branch_natural_id}, "customer/branch",()=>{
          this.requestData(baseUrl + "customer/user", {customer_user_natural_id}, "customer/user",()=>{
            this.setState({
              customer_table: 'on',
              branchBox:'on',
              userBox:'on',
              rowEdit: this.state.customer_data[0].index,
              selectedRowIndex: this.state.customer_branch_data[0],
              rowBranchEdit: this.state.customer_branch_data[0],
              selectionChanged: true
            });
          })
        })
      })
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }
    validateCallback(newData, callback=()=>{}){
      
      this.setState({
        ...this.state,
        ...newData.values
      }, ()=>{callback()})
    }
      handle_customer_branch_name(e){
        this.setState({customer_branch_name: e.target.value});
      }
      handle_customer_branch_tel(e){
        this.setState({customer_branch_tel: e.target.value});
      }
      handle_customer_user_name(e){
        this.setState({customer_user_name: e.target.value});
      }
      handle_customer_user_tel(e){
        this.setState({customer_user_tel: e.target.value});
      }
    render() {
      const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
      // console.log('customerSelecPopup state', this.state)
        return (
            <Modal className="modal-100" isOpen={this.state.modal}>
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleModal}>
                  <i className="tim-icons icon-simple-remove"></i>
                </button>
                <h5 className="modal-title">{"　"}</h5>
              </div>
                <ModalBody>
                <Row className="tables-tab">
                <Col xl="4" lg="6" md="6" sm="6" id="customer">
                  <Card className="card-border">
                    <CardHeader className="sub">
                      <CardTitle tag="h5" className="float-left">会社一覧</CardTitle>
{/*
                      <Button className="float-right" size="sm" href="/customer/add">
                      <i className="fas fa-plus"></i>追加
                      </Button>
*/}
                      <ButtonWithTooltipWithRole
                        button_id={(this.props.view?"BTN_A2_03_06002":"")}
                        class="float-right btn-facebook customer"
                        id="tmp"
                        icon="fas fa-plus"
                        link="/customer/add/"
                        label="追加"
                        message="会社を追加"
                        size="sm"
                        target="_blank"
                      />                         
                    </CardHeader>                
                    <CardBody className="sub">
                      <FormGroup>
                        <Row>
                          <Col lg="8" md="8" sm="12">
                            <InputText
                              label='会社名'
                              name='CUSTOMER__customer_name'
                              labelOn={true}
                              validateCallback={this.validateCallback}
                              enterCallback={(e) => this.search("customer","","",e)}
                              enterSearchFlag={true}
                              rootData={this.state}
                              validateType={'search'}
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12">
                          <ButtonWithTooltipWithRole
                            button_id={(this.props.view?"BTN_A2_03_06004":"")}
                            onclick={(e) => this.search("customer","","",e)}
                            class="float-right btn-search btn-facebook"
                            id="tmp"
                            icon="fas fa-search"
                            label="検索"
                            message="顧客を検索"
                            size="sm"
                          /> 
                            {/*
                            <Button className="btn-search" size="sm" onClick={(e) => this.search("customer","","",e)} color="facebook">
                            <i className="fas fa-search" />検索
                            </Button>
                            */}
                          </Col>
                        </Row>
                        ※最大{this.state.defaultPageSize}件まで表示しています。 

                      </FormGroup>                  
                      <ReactTable
                          data={this.state.customer_data}
                          columns={this.state.column}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='検索してください'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height display-flex "+ this.state.customer_table} 
                          getTrProps={(state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                              return {
                                onClick: e => {
                                  this.search("customer/branch",rowInfo.row.customer_id,"",e);

                                  if (rowInfo.index != this.state.rowEdit) {
                                    this.setState({
                                      rowEdit: rowInfo.index,
                                      selectedRowIndex: rowInfo.original,
                                      rowBranchEdit: null,
                                      selectionChanged: this.state.selectionChanged
                                        ? false
                                        : true
                                    });
                                  } else {
                                    this.setState({
                                      rowEdit: null,
                                      rowBranchEdit: null
                                    });
                                  }
//                                  console.log(rowInfo.index);
//                                  console.log(this.state.rowEdit);
                                },
                                style: {
                                  background:
                                    rowInfo.index === this.state.rowEdit ? "#dff2fd" : "",
                                  color:
                                    rowInfo.index === this.state.rowEdit ? "white" : "black",
                                  cursor:
                                    "pointer"
                                }
                              };
                            } else {
                              return {};
                            }
                          }}
                        />

                    </CardBody>
                  </Card>
                </Col>
                <Col xl="4" lg="6" md="6" sm="6" id="customer_branch" className={`${this.state.branchBox}`}>
                  <Card className="card-border">
                    <CardHeader className="sub">
                      <CardTitle tag="h5" className="float-left">支店一覧</CardTitle> 
                        <ButtonWithTooltipWithRole
                          button_id={(this.props.view?"BTN_A2_03_06007":"")}
                          class="float-right btn-facebook customer"
                          id="tmp"
                          icon="fas fa-plus"
                          link={"/customer/add/branch/"+this.state.customer_id}
                          label="追加"
                          message="支店を追加"
                          size="sm"
                          target="_blank"
                        />       
                      </CardHeader>                
                      <CardBody className="sub">
                        <FormGroup>
                          <Row>
                            <Col lg="8" md="8" sm="12">
                              <InputText
                                label='支店名'
                                name='CUSTOMER_BRANCH__customer_branch_name'
                                labelOn={true}
                                validateCallback={this.validateCallback}
                                enterCallback={(e) => this.search("customer/branch",this.state.customer_id,"",e)}
                                enterSearchFlag={true}
                                rootData={this.state}
                                validateType={'search'}
                              />
                              <InputText
                                label='支店TEL'
                                name='CUSTOMER_BRANCH__customer_branch_tel'
                                labelOn={true}
                                validateCallback={this.validateCallback}
                                enterCallback={(e) => this.search("customer/branch",this.state.customer_id,"",e)}
                                enterSearchFlag={true}
                                rootData={this.state}
                                validateType={'search'}
                              />
                            </Col>
                            <Col lg="3" md="3" sm="12">
                            <ButtonWithTooltipWithRole
                              button_id={(this.props.view?"BTN_A2_03_06010":"")}
                              onclick={(e) => this.search("customer/branch",this.state.customer_id,"",e)}
                              class="float-right btn-search btn-facebook"
                              id="tmp"
                              icon="fas fa-search"
                              label="検索"
                              message="支店を検索"
                              size="sm"
                            /> 
                            </Col>
                          </Row>
                          ※最大{this.state.defaultPageSize}件まで表示しています。 

                        </FormGroup>                  
                        <ReactTable
                          data={this.state.customer_branch_data}
                          columns={this.state.column_branch}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='支店は登録されていません。'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height display-flex"}
                          getTrProps={(state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                              return {
                                onClick: e => {
                                  this.search("customer/user",this.state.customer_id,rowInfo.row.customer_branch_id,e)

                                  if (rowInfo.index != this.state.rowBranchEdit) {
                                    this.setState({
                                      rowBranchEdit: rowInfo.index,
                                      selectedBranchRowIndex: rowInfo.original,
                                      selectionBranchChanged: this.state.selectionBranchChanged
                                        ? false
                                        : true
                                    });
                                  } else {
                                    this.setState({
                                      rowBranchEdit: null
                                    });
                                  }
//                                  console.log(rowInfo.index);
//                                  console.log(this.state.rowEdit);
                                },
                                style: {
                                  background:
                                    rowInfo.index === this.state.rowBranchEdit ? "#dff2fd" : "",
                                  color:
                                    rowInfo.index === this.state.rowBranchEdit ? "white" : "black",
                                  cursor:
                                    "pointer"
                                }
                              };
                            } else {
                              return {};
                            }
                          }}
                        />
                        
                      </CardBody>
                    </Card>
                </Col>
                <Col xl="4" lg="6" md="6" sm="6" id="customer_user" className={`${this.state.userBox}`}>
                  <Card className="card-border">
                      <CardHeader className="sub">
                        <CardTitle tag="h5" className="float-left">担当者</CardTitle>
                        <ButtonWithTooltipWithRole
                          button_id={(this.props.view?"BTN_A2_03_06013":"")}
                          class="float-right btn-facebook customer"
                          id="tmp"
                          icon="fas fa-plus"
                          link={"/customer/add/user/"+this.state.customer_branch_id}
                          label="追加"
                          message="担当者を追加"
                          size="sm"
                          target="_blank"
                        />                           
                      </CardHeader>                
                      <CardBody className="sub">
                        <FormGroup>
                          <Row>
                            <Col lg="8" md="8" sm="12">
                              <InputText
                                label='担当者名'
                                name='CUSTOMER_BRANCH__customer_user_name'
                                labelOn={true}
                                validateCallback={this.validateCallback}
                                enterCallback={() =>this.search("customer/user",this.state.customer_id,this.state.customer_branch_id)}
                                enterSearchFlag={true}
                                rootData={this.state}
                                validateType={'search'}
                              />
                              <InputText
                                label='担当者TEL'
                                name='CUSTOMER_BRANCH__customer_user_tel'
                                labelOn={true}
                                validateCallback={this.validateCallback}
                                enterCallback={() => this.search("customer/user",this.state.customer_id,this.state.customer_branch_id)}
                                enterSearchFlag={true}
                                rootData={this.state}
                                validateType={'search'}
                              />
                            </Col>
                            <Col lg="3" md="3" sm="12">
                            <ButtonWithTooltipWithRole
                              button_id={(this.props.view?"BTN_A2_03_06016":"")}
                              onclick={(e) => this.search("customer/user",this.state.customer_id,this.state.customer_branch_id,e)}
                              class="float-right btn-search btn-facebook"
                              id="tmp"
                              icon="fas fa-search"
                              label="検索"
                              message="担当者を検索"
                              size="sm"
                            />                       
                            </Col>
                          </Row>
                          ※最大{this.state.defaultPageSize}件まで表示しています。 

                        </FormGroup>                  
                        <ReactTable
                          data={this.state.customer_user_data}
                          columns={this.state.column_user}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='担当者は登録されていません。'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height display-flex"} 
                        />
                      </CardBody>
                    
                  </Card>
                </Col>
                </Row>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }
}
